export var allDepartmentRoleValues = ["head", "admin"];
export var DepartmentExtractors = {
    id: function (u) { return u.id; },
    name: function (u) { return u.name; },
};
